module.exports = __webpack_public_path__ + "static/White_Feather-7683bb5a959ba7e07fa0b8be4a47d47f.png";